import { createReducer } from '@ngrx/store';
import { initialState } from './state';

export const featureReducer = createReducer(initialState);
